import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fc1ab62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "ms-auto page-title" }
const _hoisted_4 = {
  id: "list-card",
  class: "__stations"
}
const _hoisted_5 = { class: "d-flex flex-row" }
const _hoisted_6 = ["title"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-video fas video" }, null, -1))
const _hoisted_8 = { class: "button-group right" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-cog fas" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-images fas" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-images fas" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-ellipsis-v fas" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-edit fas" }, null, -1))
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-eye fas" }, null, -1))
const _hoisted_16 = ["title"]
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "d-flex flex-row mt-1" }
const _hoisted_19 = { class: "date-header" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-calendar-alt fas" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-calendar-alt fas" }, null, -1))
const _hoisted_22 = { key: 2 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-calendar-alt fas" }, null, -1))
const _hoisted_24 = { class: "tag-header" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-camera fa default" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_27 = { class: "card-body" }
const _hoisted_28 = { class: "__data-items" }
const _hoisted_29 = { class: "ms-2" }
const _hoisted_30 = { class: "magnitude fw-bold" }
const _hoisted_31 = { class: "measurement" }
const _hoisted_32 = {
  key: 0,
  class: "d-flex justify-content-center p-4"
}
const _hoisted_33 = { class: "dialog-footer" }
const _hoisted_34 = { class: "dialog-footer" }
const _hoisted_35 = { class: "search-button" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-search fas" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_station_image_component = _resolveComponent("station-image-component")!
  const _component_observer_component = _resolveComponent("observer-component")!
  const _component_station_images_modal_component = _resolveComponent("station-images-modal-component")!
  const _component_station_config_form_component = _resolveComponent("station-config-form-component")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_station_form_component = _resolveComponent("station-form-component")!
  const _component_station_search_form_component = _resolveComponent("station-search-form-component")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.stations.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t("warning.notData")), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_el_card, { class: "header" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_page_header, {
          title: _ctx.$t('placeholder.goBack'),
          onBack: _ctx.goBack,
          class: "header"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("btn.stations")), 1)
            ])
          ]),
          _: 1
        }, 8, ["title", "onBack"])
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stations, (station) => {
          return (_openBlock(), _createBlock(_component_el_card, {
            class: "__station",
            key: station.id
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    class: "station left text-truncate",
                    title: station.name
                  }, [
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(station.name), 1)
                  ], 8, _hoisted_6),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_el_button, {
                      class: "btn-border",
                      onClick: ($event: any) => (_ctx.formConfigDialog(station)),
                      circle: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    (station?.lastImage)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          class: "btn-border",
                          onClick: ($event: any) => (_ctx.seeImages(station)),
                          circle: ""
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          disabled: "",
                          class: "btn-border disabled",
                          onClick: ($event: any) => (_ctx.seeImages(station)),
                          circle: ""
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 2
                        }, 1032, ["onClick"])),
                    _createVNode(_component_el_dropdown, null, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_dropdown_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  onClick: ($event: any) => (_ctx.formEntityDialog(station))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_13
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_dropdown_item, null, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  href: _ctx.$router.resolve(_ctx.generateStationDetailRoute(station)).href,
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  class: "dropdown-link"
                                }, [
                                  _createVNode(_component_el_button, null, {
                                    default: _withCtx(() => [
                                      _hoisted_15
                                    ]),
                                    _: 1
                                  })
                                ], 8, _hoisted_14)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_dropdown_item, null, {
                              default: _withCtx(() => [
                                (!station.active)
                                  ? (_openBlock(), _createBlock(_component_el_button, {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.confirmActivateItem(station))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("em", {
                                          class: "el-icon el-icon-check fas",
                                          title: _ctx.$t('btn.activate')
                                        }, null, 8, _hoisted_16)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (station.active)
                                  ? (_openBlock(), _createBlock(_component_el_button, {
                                      key: 1,
                                      onClick: ($event: any) => (_ctx.confirmDeactivateItem(station))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("em", {
                                          class: "el-icon el-icon-times fas",
                                          title: _ctx.$t('btn.deactivate')
                                        }, null, 8, _hoisted_17)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: "btn-border",
                          circle: ""
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    (
                    _ctx.checkTime(
                      station.last_data_date,
                      station.last_data_time,
                      station.send_interval
                    ) === 'danger'
                  )
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          class: "checkTimeDanger checkTime",
                          type: "danger"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_20,
                            _createTextVNode(" " + _toDisplayString(_ctx.convertDateToString(`${station.last_data_date}`, `${station.last_data_time}`)), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : (
                    _ctx.checkTime(
                      station.last_data_date,
                      station.last_data_time,
                      station.send_interval
                    ) === 'warning'
                  )
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            class: "checkTimeWarning checkTime",
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_21,
                              _createTextVNode(" " + _toDisplayString(_ctx.convertDateToString(`${station.last_data_date}`, `${station.last_data_time}`)), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _hoisted_23,
                            _createTextVNode(" " + _toDisplayString(_ctx.convertDateToString(`${station.last_data_date}`, `${station.last_data_time}`)), 1)
                          ]))
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    (station.active)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          class: _normalizeClass(_ctx.classOpticalOperation(station.lastData)),
                          circle: ""
                        }, {
                          default: _withCtx(() => [
                            _hoisted_25
                          ]),
                          _: 2
                        }, 1032, ["class"]))
                      : _createCommentVNode("", true),
                    (!station.active)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 1,
                          class: "tag deactivate red"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("btn.deactivated")), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_26
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_station_image_component, {
                  images: [
              {
                ...station?.lastImage,
                ...{ title: station.pointName },
                ...{ interval: station.send_interval },
              },
            ],
                  modal: false
                }, null, 8, ["images"]),
                _createElementVNode("div", _hoisted_28, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.index,
                      class: "__data-item p-2"
                    }, [
                      (_ctx.findMeasurement(station.lastData, item.index) === '-')
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            class: "icon-data red",
                            type: "success",
                            size: "large",
                            effect: "dark"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("em", {
                                class: _normalizeClass(`${item.icon} default`)
                              }, null, 2)
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            class: _normalizeClass(_ctx.classMagnitude(station.lastData, item.index)),
                            size: "large",
                            effect: "dark"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("em", {
                                class: _normalizeClass(`${item.icon} default`)
                              }, null, 2)
                            ]),
                            _: 2
                          }, 1032, ["class"])),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t(item.title)), 1),
                        _createElementVNode("div", _hoisted_31, _toDisplayString(`${_ctx.findMeasurement(station.lastData, item.index)}
                    ${item.index === "available_SD" ? "%" : item.index === "voltage" ? "V" : ""}`), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      (_ctx.hasMore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createVNode(_component_el_button, {
              primary: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMore()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.showMore")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_observer_component, { onIntersect: _ctx.showMore }, null, 8, ["onIntersect"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isModalImageVisible)
        ? (_openBlock(), _createBlock(_component_station_images_modal_component, {
            key: 1,
            title: _ctx.modalTitle,
            stationId: _ctx.stationId,
            onClose: _ctx.closeModalImage
          }, null, 8, ["title", "stationId", "onClose"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.showConfigEntityForm,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showConfigEntityForm) = $event)),
        title: _ctx.$t('label.configuration'),
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_33, [
            _createVNode(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeEntityDialog()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveConfiguration()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_station_config_form_component, {
            ref: "stationConfigForm",
            station: _ctx.entitySelected?.station,
            stationData: _ctx.entitySelected
          }, null, 8, ["station", "stationData"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.showEntityForm,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showEntityForm) = $event)),
        title: _ctx.$t(_ctx.entitySelected?.id ? 'label.stationEdit' : 'label.stationNew'),
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_34, [
            _createVNode(_component_el_button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeEntityDialog()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveEntity()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_station_form_component, {
            ref: "stationForm",
            station: _ctx.entitySelected?.station,
            stationData: _ctx.entitySelected
          }, null, 8, ["station", "stationData"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"]),
      _createElementVNode("div", _hoisted_35, [
        _createVNode(_component_el_popover, {
          placement: "bottom",
          width: 500,
          trigger: "click",
          onShow: _cache[7] || (_cache[7] = ($event: any) => (_ctx.stationSearchForm ? _ctx.stationSearchForm.focus() : null))
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: "btn",
              type: "primary",
              size: "large",
              circle: ""
            }, {
              default: _withCtx(() => [
                _hoisted_36
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_station_search_form_component, {
              onSearch: _ctx.doSearch,
              values: _ctx.search,
              ref: "stationSearchForm"
            }, null, 8, ["onSearch", "values"])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}